import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
function initials(author: string): string {
  return author.split(/\s+/).map(part => part.charAt(0).toUpperCase()).join('');
}
export function TestimonialsSection() {
  return <section className="defer-paint w-full bg-ivory py-10 sm:py-12" aria-labelledby="testimonials-heading" data-id="element-193" data-mp="1my7pb20877u0">
      <div className="mx-auto max-w-6xl px-6" data-id="element-194" data-mp="1d1uolk69jtpr">
        <div className="mx-auto max-w-2xl text-center" data-id="element-195" data-mp="1d135h8turogd">
          <p className="eyebrow text-sage-deep" data-id="element-196" data-mp="1i0o41i541usk">In their words</p>
          <h2 id="testimonials-heading" className="mt-5 font-display text-[2rem] leading-[1.12] text-ink sm:text-4xl" data-id="element-197" data-mp="1hyuthrrdmqfa">
            What yoga teachers are saying
          </h2>
        </div>

        <ul className="mt-11 grid gap-5 md:grid-cols-3" data-id="element-198" data-mp="1831lmlolrl3u">
          {testimonials.map(testimonial => <li key={testimonial.author} className="flex h-full flex-col rounded-3xl border border-line bg-shell p-6" data-id="element-199" data-mp="2yfp9yj647gqo">
              <div className="flex gap-1" aria-label="Rated 5 out of 5" data-id="element-200" data-mp="32eongs5wwltq">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-201" data-mp="2q39hkcd5nxd0" data-mpi={index} />)}
              </div>

              <blockquote className="mt-4 font-sans text-[0.9rem] leading-relaxed text-ink/85" data-id="element-202" data-mp="34q2puxo9c2vp">
                “{testimonial.quote}”
              </blockquote>

              <footer className="mt-auto flex items-center gap-3 pt-6" data-id="element-203" data-mp="2c26t5syouayx">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-sage-light font-sans text-[11px] font-semibold tracking-wide text-sage-deep" aria-hidden="true" data-id="element-204" data-mp="2c4jjatelnrn2">
                  {initials(testimonial.author)}
                </span>
                <span className="font-sans text-sm" data-id="element-205" data-mp="2h08deh7uogbz">
                  <span className="block font-semibold text-ink" data-id="element-206" data-mp="1a5nhawc7z7x">
                    {testimonial.author}
                  </span>
                  <span className="block text-xs text-stone" data-id="element-207" data-mp="3sg6p6suexggw">
                    {testimonial.role}, {testimonial.location}
                  </span>
                </span>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}